import Component from "@glimmer/component"
import styles from "./after-first-temp.module.css"

export default class AfterFirstTemplateComponent extends Component {
  readonly styles = styles
}
